import { render, staticRenderFns } from "./base-renewal-progress-bar.vue?vue&type=template&id=2842c045&scoped=true"
import script from "./base-renewal-progress-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./base-renewal-progress-bar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-renewal-progress-bar.vue?vue&type=style&index=0&id=2842c045&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2842c045",
  null
  
)

export default component.exports